import commons from './commons'
import brands from './brands'
import hotmart from './hotmart'
import menuIcons from './menu-icons'

export default {
  ...commons,
  ...brands,
  ...hotmart,
  ...menuIcons,
}
